module.exports = __webpack_public_path__ + "img/myvpnbook-logo.3ae94d1e.svg";